import { AnimatePresence, motion } from "framer-motion";
import { MdTaskAlt } from "react-icons/md";

interface SuccessPopUpMessageProps {
  name: string;
  nameType: string;
  showSuccessPopUp: boolean;
  setShowSuccessPopUp: React.Dispatch<React.SetStateAction<boolean>>;
  dismissAction: () => void;
  className?: string;
}

/**
 * Definition of the variants of this component
 */
const variants = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: {
    opacity: 0,
    transition: { duration: 0.2, ease: "easeOut" },
  },
};

const SuccessPopUpMessage: React.FC<SuccessPopUpMessageProps> = ({
  name,
  nameType,
  showSuccessPopUp,
  setShowSuccessPopUp,
  dismissAction,
  className = "absolute -bottom-3 w-full h-12 p-3 bg-success-500 rounded-2xl justify-start items-center gap-3 inline-flex",
}) => {
  // Definition of the dismiss button on click
  const handleOnClickDismiss = () => {
    // Execute action
    dismissAction();

    // And remove the pop up window
    setShowSuccessPopUp(false);
  };

  return (
    <AnimatePresence>
      {showSuccessPopUp && (
        <motion.div
          className={className}
          variants={variants}
          initial="initial"
          animate="animate"
          exit="exit"
          transition={{ duration: 0.3, ease: "easeOut" }}
        >
          <div className="grow shrink basis-0 h-6 justify-center items-center gap-1.5 flex">
            <MdTaskAlt className="w-6 h-6 fill-white" />
            <div className="grow shrink basis-0 text-white text-sm font-sans leading-[17px]">
              <span className="font-semibold">{name} </span>
              <span className="font-normal">
                has been added as a {nameType}
              </span>
            </div>
          </div>
          <div
            className="px-2 py-1 bg-success-600 hover:bg-success-700 ease-in-out duration-150 rounded justify-center items-center gap-2 flex cursor-pointer"
            onClick={handleOnClickDismiss}
          >
            <div className="text-white text-xs font-normal font-inter uppercase leading-[14px] tracking-wide">
              Dismiss
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default SuccessPopUpMessage;
